import { readCitizenDashboardUrl, readClaimMyRecordUrl, } from '../services/envConfig';
/**
 * Resolves the authenticated “Dashboard” control: explicit JSON `items`, legacy single `href`,
 * or env-driven Citizen / Claim URLs (`CitizenDashboardUrl`, `ClaimMyRecordUrl`, etc.).
 */
export function resolveDashboardNav(dashboardNavLink, env) {
    const d = dashboardNavLink;
    if (d?.items && Array.isArray(d.items) && d.items.length > 0) {
        const items = d.items
            .map((x) => ({
            label: (x.label ?? '').trim() || 'Link',
            href: (x.href ?? '').trim(),
        }))
            .filter((x) => x.href);
        if (items.length > 0) {
            return { label: d.label?.trim() || 'My Dashboard', items };
        }
    }
    if (d?.href?.trim()) {
        const href = d.href.trim();
        return {
            label: d.label?.trim() || 'My Dashboard',
            items: [{ label: d.label?.trim() || 'My Dashboard', href }],
        };
    }
    const citizenFromProp = d?.citizenDashboard?.href?.trim();
    const claimFromProp = d?.claimMyRecord?.href?.trim();
    const citizen = citizenFromProp || readCitizenDashboardUrl(env);
    const claim = claimFromProp || readClaimMyRecordUrl(env);
    const items = [];
    if (citizen) {
        items.push({
            label: d?.citizenDashboard?.label?.trim() || 'Citizen Dashboard',
            href: citizen,
        });
    }
    if (claim) {
        items.push({
            label: d?.claimMyRecord?.label?.trim() || 'Claim My Record',
            href: claim,
        });
    }
    if (items.length > 0) {
        return { label: d?.label?.trim() || 'My Dashboard', items };
    }
    return null;
}
